import React from 'react';

export default function ArrowRightIcon(props) {
  return (
    <svg width={props.width || "6"} height={props.height || "10"} viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M1 9L5 5L1 1" stroke={props.stroke || "#737D86"} strokeLinecap="round" strokeLinejoin="round" />
    </svg>



  )
}
